export default __webpack_public_path__ + "static/media/LOGO-COLORIDA-ATUALIZADA.b4234cd2.png";